// components/ConfigScreen.js
import React, { useState } from 'react';
import './ConfigScreen.css';

const ConfigScreen = () => {
  const [settings, setSettings] = useState({
    enableNotifications: true,
    autoSave: false,
    darkMode: false,
    emailReports: true,
    hideCompletedTasks: false,
    showTaskDetails: true
  });

  const handleSettingChange = (setting) => {
    setSettings({
      ...settings,
      [setting]: !settings[setting]
    });
  };

  const handleSave = () => {
    // Save logic would go here
    alert('Settings saved successfully!');
  };

  return (
    <div className="config-screen">
      <h1 className="config-title">Application Configuration</h1>
      
      <div className="config-card">
        <h2 className="config-section-title">General Settings</h2>
        
        <div className="config-settings">
          <div className="config-setting">
            <label className="checkbox-container">
              Enable Notifications
              <input
                type="checkbox"
                checked={settings.enableNotifications}
                onChange={() => handleSettingChange('enableNotifications')}
              />
              <span className="checkmark"></span>
            </label>
          </div>
          
          <div className="config-setting">
            <label className="checkbox-container">
              Auto-Save Changes
              <input
                type="checkbox"
                checked={settings.autoSave}
                onChange={() => handleSettingChange('autoSave')}
              />
              <span className="checkmark"></span>
            </label>
          </div>
          
          <div className="config-setting">
            <label className="checkbox-container">
              Dark Mode
              <input
                type="checkbox"
                checked={settings.darkMode}
                onChange={() => handleSettingChange('darkMode')}
              />
              <span className="checkmark"></span>
            </label>
          </div>
          
          <div className="config-setting">
            <label className="checkbox-container">
              Email Reports
              <input
                type="checkbox"
                checked={settings.emailReports}
                onChange={() => handleSettingChange('emailReports')}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </div>
      
      <div className="config-card">
        <h2 className="config-section-title">Task Display Settings</h2>
        
        <div className="config-settings">
          <div className="config-setting">
            <label className="checkbox-container">
              Hide Completed Tasks
              <input
                type="checkbox"
                checked={settings.hideCompletedTasks}
                onChange={() => handleSettingChange('hideCompletedTasks')}
              />
              <span className="checkmark"></span>
            </label>
          </div>
          
          <div className="config-setting">
            <label className="checkbox-container">
              Show Task Details by Default
              <input
                type="checkbox"
                checked={settings.showTaskDetails}
                onChange={() => handleSettingChange('showTaskDetails')}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </div>
      
      <div className="config-actions">
        <button type="button" className="btn btn-secondary">
          Cancel
        </button>
        <button type="button" className="btn btn-primary" onClick={handleSave}>
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default ConfigScreen;